import * as actionTypes from '../actions/actionTypes';
const initialState = {};

export default function app(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_PRODUCT:
      return {
        setProduct: action.state
      };
    case actionTypes.SET_REFERRER:
      state.referrer = action.payload.referrer;
      return state;
    case actionTypes.SET_KEY:
      state.noAuthKey = action.payload.noAuthKey;
      return state;
    case actionTypes.SET_NO_SALES_EMAIL:
      state.noSalesEmail = action.payload.noSalesEmail;
      return state;
    case actionTypes.SET_SURVEY_REFERRALS:
      state.surveyReferrals = action.payload.referrals;
      return state;
    case actionTypes.SET_SURVEY_INTERESTS:
      state.surveyInterests = action.payload.interests;
      return state;
    case actionTypes.CREATE_ACCOUNT:

      if (action.state) {
        state.marketoHash = action.state.marketoHash;
        state[action.type] = action.state;
      }

      return state;
    default:
      let newState = {
        ...state
      };
      if (action.state) {
        newState[action.type] = action.state;
      }
      return newState;
  }
}



/** WEBPACK FOOTER **
 ** ./src/_shared/reducers/index.js
 **/